import { render, staticRenderFns } from "./ProjectConfigBoards.vue?vue&type=template&id=0b74a046&scoped=true"
import script from "./ProjectConfigBoards.vue?vue&type=script&lang=js"
export * from "./ProjectConfigBoards.vue?vue&type=script&lang=js"
import style0 from "./ProjectConfigBoards.vue?vue&type=style&index=0&id=0b74a046&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b74a046",
  null
  
)

export default component.exports